import { render, staticRenderFns } from "./ExpenseKasbon.vue?vue&type=template&id=077d942b"
import script from "./ExpenseKasbon.vue?vue&type=script&lang=js"
export * from "./ExpenseKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports